import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerFetchRepaymentHistoryApiCallSuccess } from 'redux/actions';
import { TRIGGER_FETCH_REPAYMENT_HISTORY_API } from 'redux/actionTypes';
import { apiCall } from 'services';

function* triggerFetchRepaymentHistoryApiCall(actions) {
	const { data, callback, stopLoader } = actions;
	const PAGE_NUM = data['pageNum'];
	const PAGE_SIZE = data['pageSize'];
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE,
		url:
			API_CONSTANT.URL.REPAYMENT_HISTORY +
			API_CONSTANT.QUERY_PARAMS.PAGE_NUM +
			PAGE_NUM +
			API_CONSTANT.QUERY_PARAMS.PAGE_SIZE +
			PAGE_SIZE +
			`${data?.source ? `&source=${data.source}` : ''}`,
		method: 'GET',
		options: {
			defaultLoader: !stopLoader,
		},
		loaderDetails: {
			first_message: 'fetching your',
			start_index: 0,
			range: 9,
			second_message: 'transactions',
		},
	});
	if (api && api.data.data) {
		const apiData = api.data.data;
		apiData['dontAppend'] = data?.['dontAppend'];
		callback && callback(apiData);
		yield put(triggerFetchRepaymentHistoryApiCallSuccess(apiData, apiData?.repaymentHistory));
	}
}

export default function* triggerFetchRepaymentHistoryApiCallSaga() {
	yield takeEvery(TRIGGER_FETCH_REPAYMENT_HISTORY_API, triggerFetchRepaymentHistoryApiCall);
}
